import { ISettingsNode } from './build-settings-tree';
import { SettingsNodeProps } from '../components/settings-tree-panel/settings-tree-node.component';
import { SettingsActionDispatcher } from '../reducer/settings-tree.reducer';
import { SettingsMapper } from './mappings';

/**
 * Maps the settings tree data to the props required by the SettingsNode component.
 * @param settingsTreeRootNode
 * @param dispatch
 * @param state
 * @returns SettingsTreeProps
 */
export function mapSettingsTreeToProps(node: ISettingsNode, dispatch: SettingsActionDispatcher): SettingsNodeProps {
  return {
    icon: SettingsMapper.NodeTypeToIcon(node),
    label: node.label,
    id: node.id,
    parentId: node.parentId,
    isHidden: node.isHidden,
    isExpandableWhenEmpty: node.isExpandableWhenEmpty,
    status: node.status,
    style: node.style,
    iconStyle: SettingsMapper.NodeTypeToIconStyle(node),
    children: node.children.map((child) => mapSettingsTreeToProps(child, dispatch)),
    onClick: () =>
      dispatch({
        type: 'SELECT_NODE',
        payload: { nodeId: node.id, requestType: node.requestType, isPlaceholder: node.isPlaceholder ?? false }
      })
  };
}
